export interface Config {
  features: {
  };
  api: {
    cdnUrl: string;
  };
  analytics: {
    measurementId: string;
  };
}

let config: Config | null = null;

export const loadConfig = async (): Promise<Config> => {
  if (!config) {
    const response = await fetch('/config.json');
    config = await response.json();
  }
  return config!;
};
